import { Banner, Col, Container, Row, Typography } from 'darrius';
import { BenefitsData } from '../../../data/home/homeData';

import styles from './Benefits.module.scss';

export const Benefits = () => {
  return (
    <Banner as="section" className={`${styles['benefits']} full`}>
      <Row className="space-top">
        <Col className="col-sm-12">
          <Row className="middle-md">
            <Col className="col-sm-12">
              <Typography.Title as="h2" size="3xl">
                Benefícios para você
              </Typography.Title>
              <Row className="middle-sm space-top">
                <Col className="col-sm-12 col-md-3 center-sm">
                  <img
                    src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/partner-phone.svg`}
                    alt="Icone de economia"
                  />
                  <Row
                    className={`${styles['paragraph__benefits']} center space-bottom`}
                  >
                    <Col className="col-sm-10">
                      <Typography.Text>
                        Veja todos os pedidos <strong>sem custo</strong> e
                        invista apenas nos que quiser
                      </Typography.Text>
                    </Col>
                  </Row>
                </Col>
                <Col className="col-sm-12 col-md-3 center-sm">
                  <img
                    src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/partner-woman.png`}
                    alt="Icone de economia"
                  />
                  <Row
                    className={`${styles['paragraph__benefits']} center space-bottom`}
                  >
                    <Col className="col-sm-10">
                      <Typography.Text>
                        Receba pedidos <strong>em tempo real</strong> no seu
                        celular
                      </Typography.Text>
                    </Col>
                  </Row>
                </Col>
                <Col className="col-sm-12 col-md-3 center-sm">
                  <img
                    src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/partner-woman2.png`}
                    alt="Icone de comunicação"
                  />
                  <Row className="center space-bottom">
                    <Col className="col-sm-10">
                      <Typography.Text>
                        Converse com clientes e negocie{' '}
                        <strong>sem intermediários</strong>
                      </Typography.Text>
                    </Col>
                  </Row>
                </Col>
                <Col className="col-sm-12 col-md-3 center-sm">
                  <img
                    className="partner-money"
                    src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/partner-money.svg`}
                    alt="Icone de celular"
                  />
                  <Row className="center space-bottom">
                    <Col className="col-sm-10">
                      <Typography.Text>
                        <strong>100% do valor</strong> do serviço fica com você
                      </Typography.Text>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Banner>
  );
};
